module.exports = __webpack_public_path__ + "img/a3af26f.jpg";